import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSessionStore } from '../state/session-store.js';

/** Counts down to a scheduled geometry change so nobody is surprised by moved walls. */
export function MapChangeBanner() {
  const { t } = useTranslation();
  const scheduled = useSessionStore((s) => s.mapScheduled);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!scheduled) return;
    setNow(Date.now());
    const timer = window.setInterval(() => setNow(Date.now()), 1_000);
    return () => window.clearInterval(timer);
  }, [scheduled]);

  if (!scheduled) return null;
  const seconds = Math.max(0, Math.ceil((scheduled.applyAt - now) / 1_000));
  return (
    <div className="announcement map-change" role="status">
      {t('map.changeScheduled', { seconds })}
    </div>
  );
}
